// extracted by mini-css-extract-plugin
export var inlineLink = "_as-0";
export var inlineLinkButton = "_as-1";